export default function NotFound() {
    return (<div>404'd!</div>);
}